import React, { useState } from "react";
import { Modal, Typography, Button, Input } from "antd";
import { CloseOutlined } from "@ant-design/icons";
import { useHistory } from "react-router-dom/cjs/react-router-dom.min";
import ButtonActions from "../../../../../Components/Buttons/ButtonActions/ButtonActions";
import Spinner from "../../../../../Components/Spinner";
import { R_ACTIVITIES } from "../../../../../constants/routes";

const { Title, Paragraph } = Typography;

const CONFIRM_WORD = "MERGEAR";

const ModalMergeActivities = ({ open, onCancel, payload, onMerge }) => {
  const [step, setStep] = useState("confirm");
  const [confirmText, setConfirmText] = useState("");
  const history = useHistory();

  const handleCancel = () => {
    setStep("confirm");
    setConfirmText("");
    onCancel();
  };

  const handleConfirm = async () => {
    setStep("loading");
    const success = await onMerge(payload);

    if (success) {
      history.push(R_ACTIVITIES, { syncMerged: true });
    } else {
      setStep("input");
    }
  };

  return (
    <Modal
      modalRender={(modal) => (
        <div style={{ borderRadius: "14px", overflow: "hidden" }}>{modal}</div>
      )}
      centered
      open={open}
      onCancel={handleCancel}
      closable={step !== "loading"}
      maskClosable={step !== "loading"}
      footer={
        step === "loading" ? null : (
          <div
            style={{
              display: "flex",
              justifyContent: "flex-end",
              alignItems: "center",
              gap: "12px",
            }}
          >
            <ButtonActions
              variant="outline"
              onClick={handleCancel}
              text={step === "confirm" ? "Não" : "Cancelar"}
            />
            {step === "confirm" && (
              <ButtonActions
                variant="primary"
                onClick={() => setStep("input")}
                text="Sim"
              />
            )}
            {step === "input" && (
              <ButtonActions
                variant="primary"
                onClick={handleConfirm}
                disabled={confirmText !== CONFIRM_WORD}
                text="Confirmar"
              />
            )}
          </div>
        )
      }
      closeIcon={
        <Button
          shape="circle"
          icon={<CloseOutlined />}
          style={{
            color: "#0D6E7A",
            fontSize: "20px",
            border: "2px solid #0D6E7A",
            background: "transparent",
            borderRadius: "50%",
            padding: "5px",
            boxSizing: "border-box",
            display: "inline-block",
          }}
          onClick={handleCancel}
        />
      }
    >
      {step === "confirm" && (
        <>
          <Title
            level={4}
            style={{
              color: "#0D6E7A",
              fontSize: "24px",
              fontWeight: "600",
              margin: "15px 0 30px 20px",
            }}
          >
            Mergear selecionados
          </Title>
          <Paragraph
            style={{
              color: "#4D4D4D",
              fontSize: "16px",
              fontWeight: "400",
              margin: "15px 0 30px 20px",
            }}
          >
            Deseja realmente mergear os itens selecionados?
          </Paragraph>
        </>
      )}

      {step === "input" && (
        <>
          <Title
            level={4}
            style={{
              color: "#0D6E7A",
              fontSize: "24px",
              fontWeight: "600",
              margin: "15px 0 30px 20px",
            }}
          >
            Confirme a ação
          </Title>
          <Paragraph
            style={{
              color: "#4D4D4D",
              fontSize: "16px",
              fontWeight: "400",
              margin: "15px 0 15px 20px",
            }}
          >
            Para confirmar, digite <strong>{CONFIRM_WORD}</strong> no campo
            abaixo:
          </Paragraph>
          <Input
            value={confirmText}
            onChange={(e) => setConfirmText(e.target.value)}
            placeholder={CONFIRM_WORD}
            style={{ margin: "0 20px 30px", width: "calc(100% - 40px)" }}
          />
        </>
      )}

      {step === "loading" && (
        <div style={{ textAlign: "center", padding: "40px 0" }}>
          <Spinner />
          <Paragraph
            style={{
              color: "#4D4D4D",
              fontSize: "16px",
              fontWeight: "400",
              marginTop: "15px",
            }}
          >
            Mergeando...
          </Paragraph>
        </div>
      )}
    </Modal>
  );
};

export default ModalMergeActivities;
